module.exports = __webpack_public_path__ + "img/fi.41403716.svg";